
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import api from "../services/api";
import { ENDPOINTS } from "../services/endpoints";

const Layout = () => {
  const location = useLocation();
  const [tickerContent, setTickerContent] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  useEffect(() => {
    const fetchTickerContent = async () => {
      try {
        const response = await api.post(ENDPOINTS.CMS.PAGES, {
          page_shortname: "header_ticker",
        });
        const result = response.data;

        if (
          result?.code === 200 &&
          Array.isArray(result?.data) &&
          result.data.length > 0
        ) {
          setTickerContent(result.data[0]?.cms_content || "");
        } else {
          setTickerContent("");
        }
      } catch (err) {
        console.error("Failed to fetch header ticker CMS content:", err);
        setTickerContent("");
      }
    };

    fetchTickerContent();
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header pageShortName="header_ticker" tickerContent={tickerContent} />
      <main className="flex-fill container-fluid p-0">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
